import React, { useState, useEffect } from "react";
import { Container, Col, Row, Accordion, Button, Image, Modal, Form } from "react-bootstrap";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import trash2 from '../assets/img/trash-2.jpg';
import trash3 from '../assets/img/trash-3.jpg';
import trash4 from '../assets/img/trash-4.jpg';
import address from '../assets/icons/address.png';
import score from '../assets/icons/score.png';
import order from '../assets/icons/order.png'
import { apiUrl } from "../commons/inFormTypes";
import { ProfileUrl } from "../commons/IPAddress";
import { IPUrl } from "../commons/IPAddress";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo1 from '../assets/img/alert8.png'
import { useSpring, animated } from 'react-spring'
import BigLoaders from "../components/BigLoaders";
import OrderForm from "./OrderForm";
import Ripples from 'react-ripples'

function Dashboard() {
  let { requestId } = useParams();
  const [order, setOrder] = useState();
  const [radioText, setRadioText] = useState("");
  const [radioItem, setRadioItem] = useState(0);
  const [snip, setSnip] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [orderId, setOrderId] = useState(0);
  const [status, setStatus] = useState(true);
  const [areaId, setAreaId] = useState(0);
  const [listArea, setListArea] = useState([]);
  const [orderType, setOrderType] = useState(1);
  const [registrationFormStatus, setRegistartionFormStatus] = useState(true);
  const [show, setShow] = useState(false);
  const [Stchange, setstchange] = useState(false);
  const [seenFile, setSeenFile] = useState([]);
  const [listOredr, setListOredr] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate()


  const handleClose = () => setShow(false);
  const handleShow = (orderId) => {
    setShow(true);
    setOrder(orderId);
  }

  const acceptedBtn = useSpring({
    borderBottom: registrationFormStatus
      ? "solid 4px transparent"
      : "solid 4px #E78E09",  //Animate bottom border of login button
  });

  const waitingAcceptanceBtn = useSpring({
    borderBottom: registrationFormStatus
      ? "solid 4px #E78E09"
      : "solid 4px transparent", //Animate bottom border of register button
  });

  const waitingAcceptanceClicked = () => {
    setRegistartionFormStatus(true);
    setOrderType(1)

  }

  const acceptedClicked = () => {
    setRegistartionFormStatus(false);
    setOrderType(2)
  }


  useEffect(() => {

    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "Get_DriverOrders", {
          code: orderType,
          TokenId: userToken,
          Areaid: areaId,
        })

        .then((res) => {
          setSnip(false);
          console.log(res.data.message)
          if (res.data.result === "true") {
            setSeenFile(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });

      // const axios = require("axios");
      axios
        .post(apiUrl + "Get_ListArea")
        .then((res) => {
          if (res.data.result === "true") {
            setListArea(res.data.data);
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }, [orderType, areaId, Stchange, requestId]);



  const detailHandler = (index, val) => {
    const axios = require("axios");
    axios
      .post(apiUrl + "Get_DetailsOrders", {
        code: val,
        TokenId: userToken,
        Code_Meli: ""
      })

      .then((res) => {
        if (res.data.result === "true") {
          setListOredr(res.data.data);
        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const deleteHandler = (val) => {
    if (radioItem === 0) {
      toast.error("لطفا یکی از گزینه ها را انتخاب نمایید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "DeleteOrders", {
          reasonI_Id: radioItem,
          reason: radioText,
          code: val,
          TokenId: userToken,
          Code_Meli: "hjvhjhjh"
        })

        .then((res) => {
          console.log(res.data.result)
          setShow(false)
          if (res.data.result === "true") {
            if (Stchange) {
              setstchange(false)
            } else {
              setstchange(true)
            }
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }

  const toggleHandler = (id) => {
    if (isOpen) {
      setIsOpen(false);
      setOrderId(0);
      setStatus(true)
    }
    else {
      setIsOpen(true);
      setOrderId(id);
      setStatus(true)
    }
  };

  const confirmHandler = (id) => {

    const axios = require("axios");
    axios
      .post(apiUrl + "Edit_CofirmRequest", {
        TokenId: userToken,
        Orderid: id,
      })

      .then((res) => {
        if (res.data.result === "true") {
          if (Stchange) {
            setstchange(false)
          } else {
            setstchange(true)
          }
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const RadioHandlerChange = (val, txt) => {
    setRadioItem(val);
    setRadioText(txt);
  }

  return (
    <div>
      <main>
        <div className="pt-3 pt-lg-5">
          <Container className="m-auto">
            <Row className="justify-content-center mb-3">
              <Col xs={12} lg={10} className="mt-3">
                <Row className="justify-content-center  g-4">
                  {/* <Col xs={12} style={{ direction: "ltr" }} className="my-3">
                    <Carousel
                      autoPlay={true}
                      showThumbs={false}
                      infiniteLoop={true}
                      interval={3000}
                    >
                      <div>
                        <img className="rgc-carousel" src={trash2} alt="trash2" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={trash3} alt="trash3" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={trash4} alt="trash4" />
                      </div>
                    </Carousel>
                  </Col> */}

                  <Col xs={12} className="sub-side p-0 m-0">

                    <div className="d-flex rgc-title">
                      <div className="rgc-title-point"></div>
                      <h4>سفارشات <span>رسیده</span></h4>
                    </div>
                  </Col>

                  <Col xs={12}>
                    <Row className="justify-content-center">
                      <Col xs={4} md={3} >
                        <animated.button
                          onClick={acceptedClicked}
                          id="loginBtn"
                          style={acceptedBtn}
                          className="rgc-select-btn"
                        >
                          <span>پذیرش شده</span>

                        </animated.button>
                      </Col>

                      <Col xs={4} md={3} className="rgc-dash-filter">
                        <animated.button
                          onClick={waitingAcceptanceClicked}
                          id="registerBtn"
                          style={waitingAcceptanceBtn}
                          className="rgc-select-btn"
                        >
                          <span>در انتظار پذیرش</span>
                        </animated.button>
                      </Col>
                      
                    </Row>
                  </Col>


                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label>منطقه</Form.Label>
                      <Form.Select
                        className="rgc-select"
                        value={areaId}
                        onChange={(e) => setAreaId(e.target.value)}
                      >
                        <option key={0} value="0">
                          اهمیتی ندارد
                        </option>
                        {listArea.map((data, index) => (
                          <option key={index} value={data.ParaCode}>
                            {data.Title}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xs={12} className="text-center mt-3">
                    <BigLoaders loads={snip} />
                    <Accordion defaultActiveKey="0" flush >
                      {seenFile.length === 0 ?
                        <Col xs={12} className="rgc-orderreg-items rgc-score-body text-center" >
                          <span>سفارش موجود نیست</span>
                        </Col>
                        :
                        seenFile.map((data, index) => {
                          return (
                            <Accordion.Item className="rgc-driver-card"
                              key={index}
                              eventKey={index} onClick={() => detailHandler(index, data.Order_Id)}>
                              <Accordion.Header>
                                <Row className="juustify-content-start rgc-driver-info w-100 g-0">
                                  <Col xs={5} md={6} className="rgc-driver-image text-end text-md-center mt-2" >

                                    {data.img_Users == null ?
                                      <i className="fa fa-user-circle  rgc-avatar-icon" aria-hidden="true"></i>
                                      :
                                      <Image src={ProfileUrl + data.img_Users} className="rgc-avatar-driver" />

                                    }
                                  </Col>

                                  <Col xs={7} md={6} className="text-end mt-2">
                                    <div className="rgc-driver-btn rgc-orders-btn-edit"
                                      style={{ color: data.Color, background: data.Backcolor }} >
                                      <i class="fas fa-hourglass px-1"></i>
                                      {data.Stage_Tittle}
                                    </div>
                                  </Col>

                                  <Col xs={6} className="rgc-driver-txt text-end text-md-center">
                                    <div className="d-flex flex-column">
                                      <div>
                                        <span> نام: </span>
                                        <span>{data.Name}</span>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col xs={6} className="rgc-driver-txt text-end">
                                    <div className="d-flex flex-column">
                                      <div>
                                        <span>شماره تماس:</span>
                                        <span>{data.Mobile_User}</span>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col xs={12} md={6} className="rgc-driver-txt text-end text-md-center">
                                    <div className="d-flex flex-column">
                                      <div>
                                        <span> آدرس:</span>
                                        <span>{data.Type_Area}-{data.Address}</span>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col xs={12} md={6} className="rgc-driver-txt text-end">
                                    <div className="d-flex">
                                      <span> زمان حضور:</span>
                                      <div className="rgc-day">{data.Day}</div>
                                    </div>
                                  </Col>

                                  <Col xs={12} className="rgc-weight py-2 text-center">
                                    <div className="d-flex justify-content-center rgc-contact">
                                      <a href={`tel:${data.Mobile_User}`}>
                                        <i className="fa fa-phone"></i>
                                      </a>
                                      <i class='fas fa-comments'></i>
                                      <i class="fa fa-map-marker-alt"></i>
                                    </div>

                                  </Col>

                                  <Col xs={12} className="rgc-driver-txt text-start">
                                    <div className="d-flex justify-content-end">
                                      <div className="rgc-driver-txt-items">
                                        <span>وزن کل:</span>
                                        <span>{data.Weight}</span>
                                      </div>

                                      <div>
                                        <span> مبلغ کل:</span>
                                        <span>{Intl.NumberFormat('en-US').format((data.Coint))}</span>
                                      </div>

                                    </div>
                                  </Col>

                                </Row>
                              </Accordion.Header>
                              <Accordion.Body >
                                <hr />
                                <Row className="justify-content-start rgc-driver-content">
                                  {listOredr.map((data, index) => {
                                    return (
                                      <Col xs={12} lg={6} key={index} className="gx-md-5 gy-3">
                                        <Row className="rgc-driver-item g-0">
                                          <Col xs={2} className="text-center">
                                            <Image src={IPUrl + data.Icon} alt="" className="rgc-image" />
                                          </Col>

                                          <Col xs={10} className="text-end">
                                            <span>{data.Type_Trash_Tittle}</span>
                                          </Col>

                                          <Col xs={6} className="text-center">
                                            <span>{data.Sub_Weight}</span><span>{data.Type_Weight_Title}</span>
                                          </Col>

                                          <Col xs={6} className="text-center">
                                            <span>{Intl.NumberFormat('en-US').format((data.Sub_Coint))}</span><span>ریال</span>
                                          </Col>
                                        </Row>
                                      </Col>
                                    )
                                  })}

                                  <div className="w-100"></div>

                                  {orderType === 2 &&
                                    <Col xs={6} md={4} className="text-center mt-3 m-auto">
                                      <Button className="rgc-driver-btn rgc-driver-btn-remove"
                                        onClick={() => handleShow(data.Order_Id)}
                                      >
                                        لغو سفارش
                                      </Button>
                                    </Col>
                                  }

                                  {orderType === 2 ?
                                    <Col xs={6} md={4} className="text-center mt-3 m-auto" >
                                      <Button className="rgc-driver-btn rgc-driver-btn-edit"
                                        onClick={() => toggleHandler(data.Order_Id)}
                                      >
                                        ویرایش سفارش
                                      </Button>
                                    </Col>
                                    :
                                    <Col xs={6} md={4} className="text-center mt-3 m-auto" >
                                      <Button className="rgc-driver-btn rgc-driver-btn-edit"
                                        onClick={() => confirmHandler(data.Order_Id)}
                                      >
                                        تایید پذیرش
                                      </Button>
                                    </Col>
                                  }

                                </Row>
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                        })}
                    </Accordion>
                  </Col>

                  {/* <Col xs={12} className="sub-side">
                    <NavLink to="/admin/mainaddress">
                      <Row className="rgc-card g-0 rgc-address-card justify-content-center align-items-center">
                        <Col xs={3} className="rgc-item-img">
                          <img src={address}
                            alt=""
                            className="rgc-img-dash" />
                        </Col>

                        <Col xs={7} className="rgc-item-txt text-end">
                          <h4> ثبت آدرس جدید</h4>
                          <span> آدرس خود را برای تحویل زباله انتخاب کنید</span>
                        </Col>
                        <Col xs={2} className="rgc-item-icon me-auto">
                          <i class="fa fa-angle-left"></i>
                        </Col>
                      </Row>
                    </NavLink>
                  </Col>

                  <Col xs={12} className="sub-side">
                    <NavLink to="../wallet">
                      <Row className="rgc-card g-0 rgc-score-card justify-content-center align-items-center">
                        <Col xs={3} className="rgc-item-img">
                          <img src={score}
                            alt=""
                            className="rgc-img-dash" />
                        </Col>

                        <Col xs={7} className="rgc-item-txt text-end">
                          <h4> انتقال امتیاز</h4>
                          <span> شما می توانید امتیاز های خود را انتقال دهید</span>
                        </Col>
                        <Col xs={2} className="rgc-item-icon me-auto">
                          <i class="fa fa-angle-left"></i>
                        </Col>
                      </Row>
                    </NavLink>
                  </Col> */}

                </Row>
              </Col>
            </Row>

            <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Ripples className="rgc-ripple">
                  <Row
                    className={radioItem === 1 ?
                      "justify-content-center  rgc-modal-time rgc-station-select"
                      : "justify-content-center  rgc-modal-time"}
                  >
                    <Col xs={2}>
                      <div className="radio">
                        <input
                          type="radio"
                          value={1}
                          className="rgc-checkbox mt-2 me-2"
                          checked={radioItem === "1"}
                          onChange={(e) => RadioHandlerChange(e.target.value, 'عدم حضور شهروند')}

                        />
                      </div>
                    </Col>

                    <Col xs={5} className="text-end rgc-day">
                      <span>عدم حضور شهروند</span>
                    </Col>

                  </Row>
                </Ripples>

                <Ripples className="rgc-ripple">
                  <Row
                    className={radioItem === 2 ?
                      "justify-content-center  rgc-modal-time rgc-station-select"
                      : "justify-content-center  rgc-modal-time"}
                  >
                    <Col xs={2}>
                      <div className="radio">
                        <input
                          type="radio"
                          value={2}
                          className="rgc-checkbox mt-2 me-2"
                          checked={radioItem === "2"}
                          onChange={(e) => RadioHandlerChange(e.target.value, 'دلایل دیگر')}
                        />
                      </div>
                    </Col>

                    <Col xs={5} className="text-end rgc-day">
                      <span>دلایل دیگر</span>
                    </Col>

                  </Row>
                </Ripples>

              </Modal.Body>
              <Modal.Footer className="rgc-modal-button">
                <Button onClick={() => deleteHandler(order)}>
                  بله
                </Button>
                <Button onClick={handleClose}>
                  خیر
                </Button>

              </Modal.Footer>
            </Modal>

          </Container>
          <OrderForm Status={status} order={orderId} toggle={isOpen} toggleHandler1={toggleHandler} />
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
